<template>
  <v-btn
    v-if="user.is_teacher"
    class="mt-4 mr-3"
    color="primary"
    large
    @click="click()"
  >
    <v-icon class="mr-4">mdi-plus</v-icon>

    Ajouter un cours
  </v-btn>
  <!-- <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-btn
          v-if="user.is_teacher"
          class="mt-4 mr-3"
          color="primary"
          large
          :disabled="true"
        >
          <v-icon class="mr-4">mdi-plus</v-icon>
          Ajouter un cours
        </v-btn>
      </span>
    </template>
    <span>🚫Les cours ne sont pas encore ouverts.</span>
  </v-tooltip> -->
</template>

<script>
export default {
  name: "CardCourse",
  props: {
    user: Object,
    isAdminMode: Boolean,
  },
  methods: {
    click: function () {
      if (!this.isAdminMode) {
        this.$router.push("/createcourse");
      } else {
        this.$router.push("/createcourse/" + this.user._id);
      }
    },
  },
};
</script>
